module.exports = function (e) {
  var r = {};
  function t(a) {
    if (r[a]) return r[a].exports;
    var n = r[a] = {
      i: a,
      l: !1,
      exports: {}
    };
    return e[a].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
  }
  return t.m = e, t.c = r, t.d = function (e, r, a) {
    t.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: a
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, r) {
    if (1 & r && (e = t(e)), 8 & r) return e;
    if (4 & r && "object" == typeof e && e && e.__esModule) return e;
    var a = Object.create(null);
    if (t.r(a), Object.defineProperty(a, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var n in e) t.d(a, n, function (r) {
      return e[r];
    }.bind(null, n));
    return a;
  }, t.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return t.d(r, "a", r), r;
  }, t.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, t.p = "", t(t.s = 1);
}([function (e, r) {
  e.exports = require("react");
}, function (e, r, t) {
  "use strict";

  t.r(r), t.d(r, "parentClassname", function () {
    return O;
  }), t.d(r, "ReactForm", function () {
    return D;
  }), t.d(r, "ReactFormField", function () {
    return C;
  }), t.d(r, "ReactFormGroup", function () {
    return j;
  }), t.d(r, "Regex", function () {
    return o;
  });
  var a = t(0),
    n = t.n(a),
    o = {
      notEmpty: /^.+$/,
      digits: /^\d+$/,
      password: /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[_\W]).{8,})/,
      postcode: /^\d{3,4}$|^$/,
      name: /^[a-zA-Z\s,.'\-\\pL]+$/,
      mobileNumber: /^04(\s?[0-9]{2}\s?)([0-9]{3}\s?[0-9]{3}|[0-9]{2}\s?[0-9]{2}\s?[0-9]{2})$/,
      email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      date: /^(?!(?![02468][048]|[13579][26]00)..(?!(?!00)[02468][048]|[13579][26])...02.29)\d{4}([/-])(?=0.|1[012])(?!(0[13578]|1[02]).31|02.3)\d\d\1[012]|3[01]$/
    };
  function s(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function i(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {},
        a = Object.keys(t);
      "function" == typeof Object.getOwnPropertySymbols && (a = a.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      }))), a.forEach(function (r) {
        s(e, r, t[r]);
      });
    }
    return e;
  }
  function l(e, r) {
    if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
  }
  function c(e, r) {
    for (var t = 0; t < r.length; t++) {
      var a = r[t];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  function u(e) {
    return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function p(e) {
    return (p = "function" == typeof Symbol && "symbol" === u(Symbol.iterator) ? function (e) {
      return u(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : u(e);
    })(e);
  }
  function d(e, r) {
    return !r || "object" !== p(r) && "function" != typeof r ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : r;
  }
  function f(e) {
    return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function h(e, r) {
    return (h = Object.setPrototypeOf || function (e, r) {
      return e.__proto__ = r, e;
    })(e, r);
  }
  function v(e, r) {
    var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!t) {
      if (Array.isArray(e) || (t = function (e, r) {
        if (!e) return;
        if ("string" == typeof e) return m(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(e);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return m(e, r);
      }(e)) || r && e && "number" == typeof e.length) {
        t && (e = t);
        var a = 0,
          n = function n() {};
        return {
          s: n,
          n: function n() {
            return a >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[a++]
            };
          },
          e: function e(_e) {
            throw _e;
          },
          f: n
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o,
      s = !0,
      i = !1;
    return {
      s: function s() {
        t = t.call(e);
      },
      n: function n() {
        var e = t.next();
        return s = e.done, e;
      },
      e: function e(_e2) {
        i = !0, o = _e2;
      },
      f: function f() {
        try {
          s || null == t["return"] || t["return"]();
        } finally {
          if (i) throw o;
        }
      }
    };
  }
  function m(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for (var t = 0, a = new Array(r); t < r; t++) a[t] = e[t];
    return a;
  }
  function b(e, r) {
    if (null == e) return {};
    var t,
      a,
      n = function (e, r) {
        if (null == e) return {};
        var t,
          a,
          n = {},
          o = Object.keys(e);
        for (a = 0; a < o.length; a++) t = o[a], r.indexOf(t) >= 0 || (n[t] = e[t]);
        return n;
      }(e, r);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (a = 0; a < o.length; a++) t = o[a], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
  }
  function y(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var r = 0, t = new Array(e.length); r < e.length; r++) t[r] = e[r];
        return t;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }
  var g = function g(e) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
        t = {},
        a = ["subForm", "classes", "required", "passwordVisibility", "passwordToggleBtn", "valid", "errorMessages", "infoError", "showErrors", "hideErrors", "elementProps", "fieldComponent", "isFocused", "validators", "onUpdate", "onSuccess", "onError", "disableErrorScroll", "disableSubmitUntilValid", "pageSubmit", "accessibilityIds", "additionalPropsToClean", "fileName", "remainingCharacters", "_children", "activeLabel"].concat(y(r));
      return Object.keys(e).forEach(function (r, n) {
        a.indexOf(r) < 0 && (t[r] = e[r]);
      }), t;
    },
    E = function E() {
      var e = new Date().getTime();
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (r) {
        var t = (e + 16 * Math.random()) % 16 | 0;
        return e = Math.floor(e / 16), ("x" === r ? t : 3 & t | 8).toString(16);
      });
    },
    x = function x(e) {
      return e instanceof Date && !isNaN(e);
    },
    w = function w(e) {
      var r = e.children,
        t = b(e, ["children"]);
      return "string" == typeof r ? n.a.createElement("div", Object.assign({}, t, {
        dangerouslySetInnerHTML: {
          __html: r
        }
      })) : n.a.createElement("div", t, r);
    },
    I = [{
      ID: "email",
      validate: function validate(e) {
        return o.email.test(e.value);
      },
      error: "Please enter a valid email address."
    }, {
      ID: "digits",
      validate: function validate(e) {
        return o.digits.test(e.value);
      },
      error: "This field should only contain digits."
    }, {
      ID: "name",
      validate: function validate(e) {
        return e.value = e.value.trim(), !!e.value && o.name.test(e.value);
      },
      error: "This field should only contain letters and spaces."
    }, {
      ID: "mobile",
      validate: function validate(e) {
        return o.mobileNumber.test(e.value);
      },
      error: "Please enter a valid mobile number."
    }, {
      ID: "password",
      validate: function validate(e) {
        return o.password.test(e.value);
      },
      error: "Your password must be at least 8 characters and should include 1 uppercase letter, 1 uppercase letter, 1 number and 1 special character."
    }, {
      ID: "postcode",
      validate: function validate(e) {
        return o.postcode.test(e.value);
      },
      error: "Your postcode should be 3-4 characters long and only include digits."
    }, {
      ID: "date",
      validate: function validate(e) {
        return o.date.test(e.value);
      },
      error: "Please ensure this is a valid date and in the YYYY-MM-DD format."
    }, {
      ID: "maxFileSize",
      validate: function validate(e, r, t) {
        var a = e.ref.current.files,
          n = 1024 * parseInt(r) * 1024;
        if (!r || isNaN(n)) return !0;
        var o,
          s = v(a);
        try {
          for (s.s(); !(o = s.n()).done;) {
            if (o.value.size > n) return !1;
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
        return !0;
      },
      error: "This file should be no larger than {{validatorArguement}}mb."
    }, {
      ID: "accept",
      validate: function validate(e, r, t) {
        var a = r.replace(/\s/g, "").split(",").join("|"),
          n = new RegExp(a, "i"),
          o = e.ref.current.files;
        if (n.exec(o[0].name)) return !0;
      },
      error: "This file should be one of the following file types ({{validatorArguement}})."
    }, {
      ID: ">field",
      validate: function validate(e, r, t) {
        var a;
        return t.forEach(function (t) {
          if (t.name === r) {
            var n = x(Date.parse(t.value)) ? Date.parse(t.value) : t.value,
              o = x(Date.parse(e.value)) ? Date.parse(e.value) : e.value;
            Number(o) > Number(n) && (a = !0);
          }
        }), a;
      },
      error: "This field should be greater than {{field}}."
    }, {
      ID: ">=field",
      validate: function validate(e, r, t) {
        var a;
        return t.forEach(function (t) {
          if (t.name === r) {
            var n = x(Date.parse(t.value)) ? Date.parse(t.value) : t.value,
              o = x(Date.parse(e.value)) ? Date.parse(e.value) : e.value;
            Number(o) >= Number(n) && (a = !0);
          }
        }), a;
      },
      error: "This field should be greater than or equal to {{field}}."
    }, {
      ID: ">",
      validate: function validate(e, r) {
        return Number(e.value) > Number(r);
      },
      error: "This field should be greater than {{validatorArguement}}."
    }, {
      ID: ">=",
      validate: function validate(e, r) {
        return Number(e.value) >= Number(r);
      },
      error: "This field should be greater than or equal to {{validatorArguement}}."
    }, {
      ID: "<field",
      validate: function validate(e, r, t) {
        var a;
        return t.forEach(function (t) {
          if (t.name === r) {
            var n = x(Date.parse(t.value)) ? Date.parse(t.value) : t.value,
              o = x(Date.parse(e.value)) ? Date.parse(e.value) : e.value;
            Number(o) < Number(n) && (a = !0);
          }
        }), a;
      },
      error: "This field should be less than {{field}}."
    }, {
      ID: "<=field",
      validate: function validate(e, r, t) {
        var a;
        return t.forEach(function (t) {
          if (t.name === r) {
            var n = x(Date.parse(t.value)) ? Date.parse(t.value) : t.value,
              o = x(Date.parse(e.value)) ? Date.parse(e.value) : e.value;
            Number(o) <= Number(n) && (a = !0);
          }
        }), a;
      },
      error: "This field should be less than or equal to {{field}}."
    }, {
      ID: "<",
      validate: function validate(e, r) {
        return Number(e.value) < Number(r);
      },
      error: "This field should be less than {{validatorArguement}}."
    }, {
      ID: "<=",
      validate: function validate(e, r) {
        return Number(e.value) <= Number(r);
      },
      error: "This field should be less than or equal to {{validatorArguement}}."
    }, {
      ID: "minLength",
      validate: function validate(e, r, t) {
        if (e.value.trim().length >= r) return !0;
      },
      error: "This field should at least {{validatorArguement}} characters."
    }, {
      ID: "maxLength",
      validate: function validate(e, r, t) {
        if (e.value.trim().length <= r) return !0;
      },
      error: "This field should no longer than {{validatorArguement}} characters."
    }],
    _ = function _(e) {
      var r = O ? "".concat(O, "__field") : "field",
        t = e.labelplaceholder ? "".concat(r, "__label--labelplaceholder") : "";
      return n.a.createElement("div", {
        className: "".concat(r, " \n                ").concat(r, "--").concat(e.type, "\n                ").concat(e.classes.inheritedClasses, " \n                ").concat(e.classes.isDisabled, " \n                ").concat(e.classes.isIncomplete, " \n                ").concat(e.classes.isFocused, " \n                ").concat(e.classes.hasValue, "\n                ").concat(e.classes.isValid, "\n                ").concat(e.classes.isInvalid, "\n                ").concat(e.classes.isChecked, "\n            ")
      }, n.a.createElement("label", {
        htmlFor: e.accessibilityIds.input
      }, e.label ? n.a.createElement("div", {
        className: "".concat(r, "__label  ").concat(t)
      }, n.a.createElement(w, {
        className: "".concat(r, "__label__inner"),
        id: e.accessibilityIds.label
      }, e.label), e.activeLabel ? n.a.createElement(w, {
        className: "".concat(r, "__label__active")
      }, e.activeLabel) : null) : null, e.inputElement, e.passwordToggleBtn, "checkbox" === e.type ? n.a.createElement("div", {
        className: "".concat(r, "__checkbox-indicator")
      }) : null, "radio" === e.type ? n.a.createElement("div", {
        className: "".concat(r, "__radio-indicator")
      }) : null, "select" === e.type ? n.a.createElement("div", {
        className: "".concat(r, "__select-indicator")
      }) : null), !e.hideErrors && e.errors && e.errors.length && e.showErrors ? n.a.createElement("div", {
        className: "".concat(r, "__errors")
      }, n.a.createElement(w, {
        className: "".concat(r, "__errors__item"),
        id: e.accessibilityIds.error
      }, e.errors[0])) : null, e.info ? n.a.createElement(w, {
        className: "".concat(r, "__info"),
        id: e.accessibilityIds.description
      }, e.info) : null);
    },
    k = function k(e) {
      var r = O ? "".concat(O, "__field-group") : "field-group",
        t = e.labelplaceholder ? "".concat(r, "__label--labelplaceholder") : "";
      return n.a.createElement("fieldset", {
        className: "".concat(r, " \n                ").concat(e.classes.inheritedClasses, " \n                ").concat(e.classes.isDisabled, " \n                ").concat(e.classes.isIncomplete, " \n                ").concat(e.classes.isFocused, " \n                ").concat(e.classes.hasValue, "\n                ").concat(e.classes.isValid, "\n                ").concat(e.classes.isInvalid, "\n            ")
      }, e.label ? n.a.createElement("legend", {
        className: "".concat(r, "__label  ").concat(t)
      }, n.a.createElement(w, {
        className: "".concat(r, "__label__inner")
      }, e.label)) : null, e.info ? n.a.createElement(w, {
        className: "".concat(r, "__info")
      }, e.info) : null, e.children, !e.hideErrors && e.errors && e.errors.length && e.showErrors ? n.a.createElement("div", {
        className: "".concat(r, "__errors")
      }, n.a.createElement(w, {
        className: "".concat(r, "__errors__item")
      }, e.errors[0])) : null);
    };
  function S(e, r) {
    var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!t) {
      if (Array.isArray(e) || (t = function (e, r) {
        if (!e) return;
        if ("string" == typeof e) return F(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(e);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return F(e, r);
      }(e)) || r && e && "number" == typeof e.length) {
        t && (e = t);
        var a = 0,
          n = function n() {};
        return {
          s: n,
          n: function n() {
            return a >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[a++]
            };
          },
          e: function e(_e3) {
            throw _e3;
          },
          f: n
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o,
      s = !0,
      i = !1;
    return {
      s: function s() {
        t = t.call(e);
      },
      n: function n() {
        var e = t.next();
        return s = e.done, e;
      },
      e: function e(_e4) {
        i = !0, o = _e4;
      },
      f: function f() {
        try {
          s || null == t["return"] || t["return"]();
        } finally {
          if (i) throw o;
        }
      }
    };
  }
  function F(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for (var t = 0, a = new Array(r); t < r; t++) a[t] = e[t];
    return a;
  }
  var N = function (e) {
    function r() {
      var e, t;
      l(this, r);
      for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++) o[s] = arguments[s];
      return (t = d(this, (e = f(r)).call.apply(e, [this].concat(o)))).state = {
        valid: !1,
        inputs: [],
        groups: []
      }, t.formRef = n.a.createRef(), t.submit = function (e) {
        t.submitForm(e);
      }, t.reset = function () {
        t.setState({
          inputs: []
        }, function () {
          t.setInputsInState(t.props.children);
        });
      }, t;
    }
    var t, a, o;
    return function (e, r) {
      if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(r && r.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), r && h(e, r);
    }(r, e), t = r, (a = [{
      key: "componentWillMount",
      value: function value() {
        this.validators = this.mergeValidators(), this.setInputsInState(this.props.children);
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(e) {
        this.setInputsInState(e.children);
      }
    }, {
      key: "handleInputChanged",
      value: function value(e) {
        var r = this,
          t = e.target,
          a = this.state.inputs.map(function (e) {
            return e.name === t.name && (e.controlled || ("checkbox" === e.type ? e.value = t.checked : "radio" === e.type ? e.value = t.value : "file" === e.type ? t.files && t.files.length > 0 ? t.multiple ? e.value = t.files : e.value = t.files[0] : e.value = "" : e.value = t.value), r.validateInput(e)), e;
          });
        this.setState({
          inputs: a
        }), this.props.disableFormValidateOnChange || this.validateForm(), this.props.onUpdate && this.props.onUpdate(this.prepareFormData(), this.state.inputs);
      }
    }, {
      key: "handleInputBlured",
      value: function value(e) {
        var r = this;
        if ("file" !== e.target.type) {
          var t = e.target,
            a = this.state.inputs.map(function (e) {
              return e.name === t.name && (r.validateInput(e, !0), e.isFocused = !1), e;
            });
          this.setState({
            inputs: a
          });
        }
      }
    }, {
      key: "handleInputFocused",
      value: function value(e) {
        if ("file" !== e.target.type) {
          var r = e.target,
            t = this.state.inputs.map(function (e) {
              return e.name === r.name && (e.isFocused = !0), e;
            });
          this.setState({
            inputs: t
          });
        }
      }
    }, {
      key: "handleFormSubmit",
      value: function value(e) {
        this.submitForm(e);
      }
    }, {
      key: "mergeValidators",
      value: function value() {
        return this.props.validators && this.props.validators.length > 0 && this.props.validators.forEach(function (e) {
          var r;
          I.forEach(function (t) {
            e.ID === t.ID && (r = !0, console.error("ReactForm: The custom props validator '".concat(e.ID, "' was not added as there is already a default validator with the same ID.")));
          }), r || I.push(e);
        }), I;
      }
    }, {
      key: "setInputsInState",
      value: function value(e) {
        var r = this;
        this.childFields = [], this.childGroups = [], this.recursiveMap(e, this.getInputs.bind(this));
        var t,
          a = this.state.inputs.filter(function (e) {
            var t,
              a = S(r.childFields);
            try {
              for (a.s(); !(t = a.n()).done;) {
                var n = t.value;
                if (e.name === n.props.name) return !0;
              }
            } catch (e) {
              a.e(e);
            } finally {
              a.f();
            }
          }),
          o = S(this.childFields);
        try {
          var s = function s() {
            var e = t.value,
              o = void 0;
            if (a.forEach(function (r, t) {
              if (r.name === e.props.name) if (o = !0, a[t] = i({}, r, e.props), "radio" === e.props.type) e.props.checked || e.props.defaultChecked && e.props.value ? a[t].value = e.props.value : a[t].value = r.value;else if ("select" === e.props.type && e.props.children) {
                var n = e.props.children[0].props.value,
                  s = !1;
                if (r.children.map(function (e) {
                  return e.props.value;
                }).join(",") !== e.props.children.map(function (e) {
                  return e.props.value;
                }).join(",") && (s = !0), a[t].value) {
                  if (s) {
                    var l = !1;
                    e.props.children.forEach(function (e) {
                      String(e.props.value) === String(a[t].value) && (l = !0);
                    }), l || (a[t].value = n);
                  }
                } else a[t].value = n;
              }
            }), !o) {
              var s = i({
                ref: n.a.createRef()
              }, e.props);
              if (e.props.defaultValue ? (s.value = e.props.defaultValue, s.controlled = e.props.hasOwnProperty("value")) : "checkbox" === e.props.type && (e.props.checked || e.props.defaultChecked) ? (s.value = !0, s.controlled = e.props.hasOwnProperty("checked")) : "radio" === e.props.type ? (s.value = e.props.checked || e.props.defaultChecked ? e.props.value : "", s.controlled = e.props.hasOwnProperty("checked")) : "select" === e.props.type && e.props.children && (s.value = e.props.value || e.props.children[0] ? e.props.children[0].props.value : "", s.controlled = e.props.hasOwnProperty("value")), a.push(s), s.validators) {
                var l,
                  c = S(s.validators);
                try {
                  for (c.s(); !(l = c.n()).done;) {
                    var u,
                      p = l.value.split(":")[0],
                      d = void 0,
                      f = S(r.validators);
                    try {
                      for (f.s(); !(u = f.n()).done;) u.value.ID === p && (d = !0);
                    } catch (e) {
                      f.e(e);
                    } finally {
                      f.f();
                    }
                    d || console.error("ReactForm: ReactFormField '".concat(s.name, "': No matching validator for the '").concat(p, "' validator ID could be found."));
                  }
                } catch (e) {
                  c.e(e);
                } finally {
                  c.f();
                }
              }
            }
          };
          for (o.s(); !(t = o.n()).done;) s();
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
        a.forEach(function (e, r) {
          delete e.defaultValue, delete e.defaultChecked;
        });
        var l,
          c = this.state.groups.filter(function (e) {
            var t,
              a = S(r.childGroups);
            try {
              for (a.s(); !(t = a.n()).done;) {
                var n = t.value;
                if (e.name === n.props.name) return !0;
              }
            } catch (e) {
              a.e(e);
            } finally {
              a.f();
            }
          }),
          u = S(this.childGroups);
        try {
          var p = function p() {
            var e = l.value;
            c.forEach(function (r, t) {
              r.name === e.props.name && (c[t] = i({}, r, e.props));
            });
            var r = i({
              ref: n.a.createRef()
            }, e.props);
            c.push(r);
          };
          for (u.s(); !(l = u.n()).done;) p();
        } catch (e) {
          u.e(e);
        } finally {
          u.f();
        }
        this.setState({
          inputs: a,
          groups: c
        }, function () {
          r.validateForm();
        });
      }
    }, {
      key: "validateGroup",
      value: function value(e, r) {
        e.showErrors = !(!e.showErrors && !r), e.errors = [], e.valid = !0;
        var t = [],
          a = (this.recursiveMap(e._children, function (e) {
            e.props.name && t.push(e.props.name);
          }), 0);
        this.state.inputs.forEach(function (e) {
          t.includes(e.name) && "checkbox" === e.type && e.value && a++;
        }), e.minCheckboxes && a < e.minCheckboxes && (e.valid = !1, e.errors.push(e.errorMessages && e.errorMessages.minCheckboxes ? e.errorMessages.minCheckboxes : "Please select at least ".concat(e.minCheckboxes, " checkboxes from this area."))), e.maxCheckboxes && a > e.maxCheckboxes && (e.valid = !1, e.errors.push(e.errorMessages && e.errorMessages.maxCheckboxes ? e.errorMessages.maxCheckboxes : "Please select at most ".concat(e.minCheckboxes, " checkboxes from this area."))), this.state.groups.forEach(function (r) {
          r.name === e.name && (r = e);
        }), this.setState({
          groups: this.state.groups
        });
      }
    }, {
      key: "validateInput",
      value: function value(e, r) {
        var t = this;
        if (e.showErrors = !(!e.showErrors && !r), e.errors = [], e.required ? (e.valid = !!e.value, e.valid || (e.errorMessages && e.errorMessages.required ? e.errors.push(e.errorMessages.required) : "checkbox" === e.type ? e.errors.push("Please check this field.") : "radio" === e.type || "select" === e.type ? e.errors.push("Please select an option.") : e.errors.push("Please enter a value for this field."))) : e.valid = !0, e.value && e.validators && e.validators.length > 0) {
          var a = !1;
          e.accept && e.validators.push("accept:".concat(e.accept)), this.validators.forEach(function (r) {
            e.validators.forEach(function (n) {
              var o = n.split(":")[0],
                s = n.split(":")[1];
              if (o === r.ID && !r.validate(e, s, t.state.inputs)) if (a = !0, e.errorMessages && e.errorMessages[r.ID]) e.errors.push(e.errorMessages[r.ID]);else {
                var i = r.error.replace("{{validatorArguement}}", s);
                t.state.inputs.forEach(function (e) {
                  e.name === s && (i = r.error.replace("{{field}}", e.label || s));
                }), e.errors.push(i);
              }
            }), e.valid = !a;
          });
          var n,
            o = S(this.state.inputs);
          try {
            for (o.s(); !(n = o.n()).done;) {
              var s = n.value;
              if (s.match) {
                var i,
                  l = S(this.state.inputs);
                try {
                  for (l.s(); !(i = l.n()).done;) {
                    var c = i.value;
                    c.name === s.match && (s.value !== c.value ? (s.valid = !1, s.errors = s.errors ? s.errors : [], s.errorMessages && s.errorMessages.match ? s.errors.push(e.errorMessages.match) : s.errors.push("Please ensure this field matches the '".concat(c.label ? c.label : c.placeholder, "' field."))) : (s.valid = !0, s.errors = null));
                  }
                } catch (e) {
                  l.e(e);
                } finally {
                  l.f();
                }
              }
            }
          } catch (e) {
            o.e(e);
          } finally {
            o.f();
          }
        }
        this.state.inputs.forEach(function (r) {
          r.name === e.name && (r = e);
        }), this.setState({
          inputs: this.state.inputs
        });
      }
    }, {
      key: "validateForm",
      value: function value(e) {
        var r,
          t,
          a = !0,
          n = S(this.state.inputs);
        try {
          for (n.s(); !(t = n.n()).done;) {
            var o = t.value;
            this.validateInput(o, e), o.valid || (a = !1, e && !r && (r = o));
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
        var s,
          i = S(this.state.groups);
        try {
          for (i.s(); !(s = i.n()).done;) {
            var l = s.value;
            this.validateGroup(l, e), l.valid || (a = !1, e && !r && (r = l));
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        r && !this.props.disableErrorScroll && this.scrollToInput(r), this.formValid = a, this.setState({
          valid: a
        });
      }
    }, {
      key: "resetErrors",
      value: function value() {
        var e,
          r = S(this.state.inputs);
        try {
          for (r.s(); !(e = r.n()).done;) e.value.showErrors = !1;
        } catch (e) {
          r.e(e);
        } finally {
          r.f();
        }
      }
    }, {
      key: "scrollToInput",
      value: function value(e) {
        if (e.ref.current) {
          var r = e.ref.current.getBoundingClientRect().top + document.documentElement.scrollTop || document.body.scrollTop;
          window.scrollTo(0, r - e.ref.current.clientHeight);
        }
      }
    }, {
      key: "prepareFormData",
      value: function value(e) {
        var r,
          t = e ? new FormData() : {},
          a = S(this.state.inputs);
        try {
          for (a.s(); !(r = a.n()).done;) {
            var n = r.value;
            n.disabled || (e ? t.append(n.name, n.fileValue ? n.fileValue : n.value || "") : t[n.name] = n.fileValue ? n.fileValue : n.value ? n.value : "checkbox" !== n.type && "");
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
        return t;
      }
    }, {
      key: "submitForm",
      value: function value(e) {
        this.validateForm(!0), this.formValid ? (!this.props.pageSubmit && e && e.preventDefault(), this.props.onSuccess ? this.props.onSuccess(this.prepareFormData(), this.state.inputs, e, this.prepareFormData(!0)) : console.error("No onSuccess callback prop found on ReactForm component.")) : (this.props.onError && this.props.onError(this.prepareFormData(), this.state.inputs), e && e.preventDefault());
      }
    }, {
      key: "recursiveMap",
      value: function value(e, r, t) {
        var a = this;
        return n.a.Children.map(e, function (e) {
          return n.a.isValidElement(e) ? (e.props.children && (e = "ReactFormGroup" === e.type.displayName ? n.a.cloneElement(e, {
            children: a.recursiveMap(e.props.children, r),
            _children: e.props.children
          }) : n.a.cloneElement(e, {
            children: a.recursiveMap(e.props.children, r)
          })), e ? r(e) : void 0) : e;
        });
      }
    }, {
      key: "getInputs",
      value: function value(e, r) {
        if (e) if ("ReactFormGroup" === e.type.displayName) this.childGroups.push(e);else {
          if ("ReactFormField" !== e.type.displayName) return n.a.cloneElement(e, {
            key: r
          });
          this.childFields.push(e);
        }
      }
    }, {
      key: "renderPasswordVisiblityToggle",
      value: function value(e) {
        return n.a.createElement("button", {
          type: "button",
          children: "Show",
          className: "".concat(O, "__field__password-toggle"),
          onClick: function onClick(r) {
            "password" === e.ref.current.type ? (e.ref.current.type = "text", r.target.innerHTML = "Hide", r.target.classList.add("is-active")) : (e.ref.current.type = "password", r.target.innerHTML = "Show", r.target.classList.remove("is-active"));
          }
        });
      }
    }, {
      key: "renderChild",
      value: function value(e, r) {
        if ("ReactFormField" === e.type.displayName) return this.renderFieldByName(e, r);
        if ("ReactFormGroup" === e.type.displayName) return this.renderFieldGroupByName(e, r);
        if (e.props && "submit" === e.props.type) {
          var t = !!this.props.disableSubmitUntilValid && !this.formValid,
            a = t ? " is-disabled " : "";
          return n.a.cloneElement(e, {
            key: r,
            disabled: e.props.disabled ? e.props.disabled : t,
            className: "".concat(e.props.className ? e.props.className : "", "  ").concat(a)
          });
        }
        return n.a.cloneElement(e, {
          key: r
        });
      }
    }, {
      key: "renderFieldGroupByName",
      value: function value(e, r) {
        var t,
          a = S(this.state.groups);
        try {
          for (a.s(); !(t = a.n()).done;) {
            var o = t.value;
            if (o.name === e.props.name) {
              var s = i({}, e.props, {
                label: e.props.labelplaceholder || e.props.label,
                errors: o.errors,
                showErrors: o.showErrors,
                classes: {
                  inheritedClasses: o.className ? " " + o.className : "",
                  isDisabled: o.disabled ? "is-disabled" : "",
                  isFocused: o.isFocused ? "is-focused" : "",
                  isIncomplete: o.value ? "" : "is-incomplete",
                  isValid: o.valid ? "is-valid" : "",
                  isInvalid: o.showErrors && !o.valid ? "is-invalid" : "",
                  hasValue: o.value ? "has-value" : ""
                }
              });
              return e.props.fieldComponent ? n.a.createElement(e.props.fieldComponent, Object.assign({}, s, {
                ref: null
              }), e) : n.a.createElement(k, s, e);
            }
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
      }
    }, {
      key: "renderFieldByName",
      value: function value(e, r) {
        var t,
          a,
          o = this,
          s = S(this.state.inputs);
        try {
          for (s.s(); !(t = s.n()).done;) {
            var l = t.value;
            if (l.name === e.props.name) {
              var c = e.props.id || E(),
                u = "label-".concat(c),
                p = e.props.info ? "description-".concat(c) : "",
                d = l.showErrors && l.errors.length > 0 ? "error-".concat(c) : "",
                f = i({}, e.props, {
                  label: e.props.labelplaceholder || e.props.label,
                  placeholder: e.props.labelplaceholder ? "" : e.props.placeholder,
                  errors: l.errors,
                  showErrors: l.showErrors,
                  remainingCharacters: l.maxLength && l.value ? String(l.maxLength - l.value.length) : l.maxLength ? l.maxLength : null,
                  type: l.passwordVisible ? "text" : l.type,
                  file: "file" === l.type && l.value ? l.value : {},
                  files: "file" === l.type && l.value && l.files ? l.files : null,
                  accessibilityIds: {
                    input: c,
                    label: u,
                    description: p,
                    error: d
                  },
                  id: c,
                  "aria-labelledby": e.props["aria-labelledby"] || e.props.label ? u : null,
                  "aria-describedby": e.props["aria-describedby"] || [p, d].filter(function (e) {
                    return !!e;
                  }).join(" ") || null,
                  "aria-invalid": !(!l.showErrors || l.valid),
                  classes: {
                    inheritedClasses: l.className ? " " + l.className : "",
                    isDisabled: l.disabled ? "is-disabled" : "",
                    isFocused: l.isFocused ? "is-focused" : "",
                    isIncomplete: l.value ? "" : "is-incomplete",
                    isValid: l.valid && l.required ? "is-valid" : "",
                    isInvalid: l.showErrors && !l.valid ? "is-invalid" : "",
                    hasValue: l.value ? "has-value" : "",
                    isChecked: "radio" !== l.type && "checkbox" !== l.type || l.value !== e.props.value ? "" : "is-checked"
                  },
                  onChange: function onChange(r) {
                    e.props.onChange && e.props.onChange(r), o.handleInputChanged(r);
                  },
                  onFocus: function onFocus(r) {
                    e.props.onFocus && e.props.onFocus(r), o.handleInputFocused(r);
                  },
                  onBlur: function onBlur(r) {
                    e.props.onBlur && e.props.onBlur(r), o.handleInputBlured(r);
                  }
                });
              if (f.inputElement = n.a.createElement((a = e.props.type, -1 !== ["checkbox", "radio", "email", "text", "number", "tel", "password", "file", "date", "datetime-local"].indexOf(a) ? "input" : "textarea" === a ? "textarea" : "select" === a ? "select" : void 0), i({}, g(f, this.props.additionalPropsToClean), {
                ref: e.ref || l.ref
              })), f.passwordToggleBtn = "password" === l.type ? this.renderPasswordVisiblityToggle(f.inputElement) : null, e.props.fieldComponent) return n.a.createElement(e.props.fieldComponent, Object.assign({}, f, {
                ref: null
              }));
              if (this.props.fieldComponent) return n.a.createElement(this.props.fieldComponent, Object.assign({}, f, {
                ref: null
              }));
              if (-1 !== ["checkbox", "radio", "email", "text", "number", "tel", "password", "select", "file", "textarea", "date", "datetime-local"].indexOf(l.type)) return n.a.createElement(_, Object.assign({}, f, {
                ref: null
              }));
              console.error("ReactForm: The ReactFormField with name ".concat(l.name, " does not match the available input types for the default field template and was not provided a component template via the 'fieldComponent' prop."));
            }
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          r = this.props.subForm ? "div" : "form",
          t = this.recursiveMap(this.props.children, this.renderChild.bind(this));
        return n.a.createElement(r, Object.assign({}, g(this.props, this.props.additionalPropsToClean), {
          ref: this.formRef,
          onSubmit: function onSubmit(r) {
            return e.handleFormSubmit(r);
          },
          className: "react-form ".concat(this.props.className ? this.props.className : "")
        }), t);
      }
    }]) && c(t.prototype, a), o && c(t, o), r;
  }(a.Component);
  N.defaultProps = {
    pageSubmit: !1,
    additionalPropsToClean: []
  };
  var D = N,
    O = "react-form",
    C = function C(e) {
      return null;
    };
  C.displayName = "ReactFormField";
  var j = function j(e) {
    return e.children;
  };
  j.displayName = "ReactFormGroup";
}]);